<template>
  <div class="e-dialogswrapper">
    <transition name="slide-to-left">
      <MessageList
        v-show="!dialogOpen && !newMessageEditorIsOpen"
        :items="dialogs"
        :is-loading="isLoading"
        :loading-item-id="loadingDialogId"
        :selected-item-id="currentDialogId"
        @select="onDialogSelection"
      />
    </transition>

    <transition mode="out-in" name="dialog-container">
      <component
        :is="dialogComponent"
        :key="'dialog' + currentDialogId"
        @dialog-change="onDialogChange"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Dialogs from 'organisms/DialogWrapper/DialogWrapper'
import NewDialog from './NewDialog'
import MessageList from 'organisms/MessageList/MessageList'
import DialogModel from 'store/models/Dialog'
import DialogMessageModel from 'store/models/DialogMessage'

export default {
  name: 'DialogTemplate',
  components: {
    Dialogs,
    MessageList,
    NewDialog
  },
  data() {
    return {
      dialogComponent: null
    }
  },
  computed: {
    ...mapGetters([
      'currentDialogId',
      'currentRouteName',
      'dialogs',
      'dialogOpen',
      'messageEditorOpen',
      'isLoading',
      'loadingDialogId',
      'userId',
      'userInfo'
    ]),
    dialogState() {
      return {
        dialogId: this.currentDialogId,
        currentRoute: this.currentRouteName
      }
    },
    newMessageEditorIsOpen() {
      return this.$route.name === 'newDialog'
    },
    dialogSelected() {
      return typeof this.currentDialogId !== 'undefined'
    }
  },
  watch: {
    dialogState() {
      this.setDialogVisibility()
    },
    $route: function() {
      this.loadView()
    },
    'userInfo.unreadCount': {
      handler: function(newVal, oldVal) {
        if (newVal > oldVal) {
          DialogModel.fetchByUserId(this.userId)
        }
      }
    }
  },
  created: async function() {
    try {
      await DialogModel.fetchByUserId(this.userId)
      this.setDialogVisibility()
      await this.loadDialogMessages()
    } catch (e) {
      this.$error(e)
    }
    this.setComponentName()
  },
  destroyed() {
    this.setDialogOpen(false)
  },
  methods: {
    ...mapActions(['setDialogOpen']),

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    setComponentName() {
      if (this.currentRouteName === 'dialog') {
        this.dialogComponent = 'dialogs'
      }
      if (this.currentRouteName === 'newDialog') {
        this.dialogComponent = this.currentRouteName
      }
    },

    async loadView() {
      const oldComponentName = this.dialogComponent
      this.dialogComponent = null

      if (oldComponentName !== null) await this.sleep(500) // wait for transition to end

      await this.loadDialogMessages()
      this.setComponentName()

      return true
    },

    async loadDialogMessages() {
      if (
        this.dialogSelected &&
        this.loadingDialogId !== this.currentDialogId
      ) {
        await DialogMessageModel.fetchDialogMessages(
          this.userId,
          this.currentDialogId
        )
      }
    },
    setDialogVisibility() {
      this.setDialogOpen(this.dialogSelected)
    },
    onDialogSelection(dialog) {
      if (dialog === null || this.currentDialogId === dialog.id) {
        if (this.$route.name !== 'dialogs') {
          this.$router.push({ name: 'dialogs' })
        }
        return
      }
      if (dialog.threadCount <= 1 && dialog.draft === true) {
        this.$router.push({
          name: 'newDialog',
          params: { dialogId: dialog.id }
        })
        return
      }
      this.$router.push({ name: 'dialog', params: { dialogId: dialog.id } })
    },
    async onDialogChange() {
      this.loadDialogMessages()
      await DialogModel.fetchByUserId(this.userId)
    }
  }
}
</script>
